import { Container, Card, Form, Table, Button, ButtonGroup, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import { ThreeDots } from 'react-loader-spinner';
import { listStaffOnList, updateSearch, updateCurrentPage, CountStaffOnList, allStaffOnList } from "../../3.Store/StaffOnLeaveSlice";
import Pagination from "../../2.Commons/Pagination";

const StaffOnLeaveList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lists = useSelector(state => state.StaffOnLeaveSlice.lists);
  const listsall = useSelector(state => state.StaffOnLeaveSlice.listsall);
  const search = useSelector((state) => state.StaffOnLeaveSlice.search);
  const currentPage = useSelector((state) => state.StaffOnLeaveSlice.currentPage);
  const totalPages = useSelector((state) => state.StaffOnLeaveSlice.totalPages);
  const { searchText } = search;
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const roles = JSON.parse(localStorage.getItem("roles"));
  const isHR = roles.includes("HR-L-REC") || roles.includes("SU-L-APPROVAL") || roles.includes("SU-M-BENEFIT");

  //use to filter the table based on searchText
  const [filteredStaffList, setFilteredStaffList] = useState(lists || []);

  // useEffect(() => {
  //   setLoading(true);
  //   dispatch(allStaffOnList())
  //   .then(() => {
  //     dispatch(listStaffOnList({page:currentPage}))
  //     dispatch(CountStaffOnList());
  //     setLoading(false);
  //   })
  //   .catch(() => {
  //     setLoading(false);
  //   });
  // }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await dispatch(allStaffOnList()); // Wait for first dispatch
        await dispatch(listStaffOnList({ page: currentPage })); // Wait for second
        await dispatch(CountStaffOnList()); // Wait for third
      } catch (error) {
        console.error("Failed to load staff data", error);
      } finally {
        setLoading(false); // Ensure loading is turned off in all cases
      }
    };
  
    fetchData();
  }, []);  

  useEffect(() => {
    if(searchText !== "") {
      setFilteredStaffList(
        (listsall || []).filter(employee =>
          employee.employee.fullname.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    }
    else {
      setFilteredStaffList(
        (lists || []).filter(employee =>
          employee.employee.fullname.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    }
  }, [lists, searchText, listsall]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSearch = (e) => {
    const entity = {...search, searchText: e.target.value}
    console.log(entity)
    dispatch(updateSearch(entity));
  }

  const handleBtnBack = () => {
    navigate("/");
  };

  const handlePreviousPage = () => {
    setLoading(true);
    if (currentPage > 1) {
      dispatch(updateCurrentPage(currentPage - 1));
      dispatch(listStaffOnList({page:currentPage - 1}))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    }
  };

  const handleNextPage = () => {
    setLoading(true);
    if (currentPage < totalPages) {
      dispatch(updateCurrentPage(currentPage + 1));
      dispatch(listStaffOnList({page:currentPage + 1}))
      .then(() => {
          setLoading(false);
      })
      .catch(() => {
          setLoading(false);
      });
    }
  };

  const handlePageChange = (page) => {
    setLoading(true);
    dispatch(updateCurrentPage(page));
    dispatch(listStaffOnList({page: page}))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const renderStaffList = () => {
    return filteredStaffList.map(employee => (
      <tr key={employee.id} style={{ cursor: "pointer" }}>
        {isMobile ? (
          <>
            <td style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
              {employee.employee.fullname
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')}
            </td>
            <td className="text-center">
              <div style={{ textAlign: 'left', display: 'inline-block' }}>
                <div><strong>{employee.leave_type.description} ({employee.number_of_days}D)</strong></div>
                <div><strong>From: </strong><span style={{ whiteSpace: 'nowrap' }}>{moment(employee.from_date.date).format("DD MMM YYYY")} ({employee.from_ampm})</span></div>
                <div><strong>To: </strong><span style={{ whiteSpace: 'nowrap' }}>{moment(employee.to_date.date).format("DD MMM YYYY")} ({employee.to_ampm})</span></div>
              </div>
            </td>
          </>
        ) : (
          <>
            <td>
              {employee.employee.fullname
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')}
            </td>
            <td>{moment(employee.from_date.date).format("DD MMMM YYYY")} ({employee.from_ampm})</td>
            <td>{moment(employee.to_date.date).format("DD MMMM YYYY")} ({employee.to_ampm})</td>
            <td>{employee.number_of_days}</td>
            <td>{employee.leave_type.description}</td>
          </>
        )}
      </tr>
    ));
  };

  return (
    <div className="ContainerContent2">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">Staff On Leave</h1>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <Form.Control placeholder="Search" value={searchText} onChange={handleSearch} />

        <div style={{ overflowX: 'auto' }}>
          <Table className="mt-4" style={{ fontSize: "14px" }}>
            <thead>
              <tr>
              {isMobile ? (
                <>
                  <th style={{ width: "40%" }}>Staff Name</th>
                  <th style={{ width: "60%" }} className="text-center align-middle">Details</th>
                </>
              ) : (
                <>
                <th>Staff Name</th>
                <th>Date Start</th>
                <th>Date End</th>
                <th>No. of Days</th>
                <th>Leave Type</th>
                </>
              )}
              </tr>
            </thead>
            {!loading && (
              <tbody>
                {filteredStaffList.length > 0 ? (
                  renderStaffList()
                ) : (
                  <tr>
                    {isMobile ? (
                      <>
                        <td colSpan="2">No results found</td>
                      </>
                    ) : (
                      <>
                        <td colSpan="5">No results found</td>
                      </>
                    )}
                  </tr>
                )}
              </tbody>
            )}
          </Table>
        </div>

        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePreviousPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          handlePageChange={handlePageChange}
        />

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

      </Card>
    </div>
  );
};
export default StaffOnLeaveList;
